import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/util/custom-validators';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    standalone: false
})
export class PasswordComponent {

  passwordForm: FormGroup;
  successImg = "assets/icons/check.svg";
  errorImg = "assets/icons/unchecked.svg";
  @Output() readonly passwordEvent = new EventEmitter<string>();
  hasSubmitted = false;
  @Input() isLoading = false;
  @Input() title: string;

  ngOnInit(): void {
    this.passwordForm = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
        CustomValidators.isValueInRange(8, 20),
        CustomValidators.hasUpperCase(),
        CustomValidators.hasNumber(),
        CustomValidators.notWhiteSpaces(),
      ]),
      confirmPassword: new FormControl(null, [Validators.required])
    },
      CustomValidators.compareValues('password', 'confirmPassword'),
    )
  }

  /**
* A function return if the control has error
* @returns {boolean}
*/
  getError(error: string): boolean {
    return this.passwordForm.get('password')?.errors?.[error];
  }

  /**
* A function that checks if the control is invalid
* @param {string} name
* @returns {boolean}
*/
  hasErrors() {
    return HelperFunctions.controlIsInvalid(this.passwordForm);
  }


  onSubmit(): void {
    if (this.passwordForm.valid) {
      const { password } = this.passwordForm.getRawValue();
      this.passwordEvent.emit(password)
    } else {
      this.hasSubmitted = true;
      this.passwordForm.markAllAsTouched();
    }
  }
}